import React from 'react';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import { SelectField, InputField } from 'components/form';
import { EquipmentCondition } from '@trnsact/trnsact-shared-types';

export const InventoryTableFilters = () => {
  const { control, setValue, reset } = useFormContext();

  const handleVinOrStockNumberChange = (value: string) => {
    setValue('filters.stockId', value);
  };

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" component="span">
          Filters:
        </Typography>

        <Button
          variant="contained"
          onClick={() =>
            reset({
              status: 'all',
              to: moment().endOf('year'),
              from: moment().startOf('year'),
            })
          }
        >
          Reset
        </Button>
      </Stack>

      <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '1rem', alignItems: 'flex-start' }}>
        <InputField
          control={control}
          name="filters.vin"
          label="Vin or Stock Number"
          extraAction={{ cb: handleVinOrStockNumberChange }}
        />
        {/* <SelectField
          size="medium"
          label="Condition"
          control={control}
          name="filters.condition"
          options={[
            { label: 'All', value: 'all' },
            ...Object.values(EquipmentCondition).map((condition) => ({
              label: condition,
              value: condition,
            })),
          ]}
        /> */}
      </Box>
    </Stack>
  );
};
